"use client";

import styles from "./styles.module.css";
import ImageContainer from "@components/atoms/ImageContainer";
import MenuItem from "@components/atoms/MenuItem";
import languages from "config/all-config.json";
import { useLocale, useTranslations } from "next-intl";
import { usePathname, useRouter } from "next-intl/client";
import { useEffect, useState } from "react";
import routesByLocale from "routesByLocale.json";
import { LocaleKeys } from "types/LocalKeys.type";
import { Locales } from "types/Locales.type";

function redirectPage(locale: Locales, nextLocale: Locales, pathname: string) {
  const routeName = (Object.entries(routesByLocale[locale]).find(
    ([key, value]) => {
      return value === pathname;
    }
  ) || ["home"])[0];
  return (Object.entries(routesByLocale[nextLocale]).find(([key, value]) => {
    return key === routeName;
  }) || ["", "/"])[1];
}
export default function LanguageSwitcher({ isMobile }: { isMobile?: boolean }) {
  const pathname = usePathname();
  const router = useRouter();
  const locale = useLocale();
  const [currentLocale, setCurrentLocale] = useState<string>("");
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const [currentFlag, setCurrentFlag] = useState<string>("/en.webp");
  const t = useTranslations("languages");
  const [selected, setSelected] = useState<boolean>(false);

  useEffect(() => {
    languages.languages.filter((l, key) => {
      if (l.code === locale) {
        setCurrentLocale(t(`${key}.name`));
        setCurrentFlag(l.image);
        setCurrentIndex(key);
      }
      return l.code !== locale;
    });
  }, [locale]);

  return (
    <div className={styles.container}>
      <div
        className={styles["language-selector"]}
        onClick={() => {
          setSelected(!selected);
        }}
      >
        <ImageContainer
          image={`/flags${currentFlag}`}
          width={512}
          height={512}
          alt={t(`${currentIndex}.alt`)}
          title={t(`${currentIndex}.title`)}
          containerStyle={styles["container-flag"]}
          imageStyle={styles["container-flag__image"]}
        />
        <MenuItem
          title={currentLocale}
          isActive={false}
          href={pathname}
          setExpandMenu={() => false}
          style={styles["language-selector__item"]}
        />
        <svg
          width="8"
          height="5"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles["language-selector__arrow"]}
        >
          <path
            d="M3.31833 4.57545L0.0841112 1.18105C0.0301194 1.12441 0 1.04916 0 0.970914C0 0.892665 0.0301194 0.817419 0.0841112 0.760782L0.0877657 0.757127C0.11394 0.729575 0.145445 0.707637 0.180366 0.692645C0.215286 0.677653 0.252891 0.669922 0.290894 0.669922C0.328896 0.669922 0.366502 0.677653 0.401422 0.692645C0.436343 0.707637 0.467848 0.729575 0.494022 0.757127L3.53942 3.95358L6.58361 0.757127C6.60978 0.729575 6.64129 0.707637 6.67621 0.692645C6.71113 0.677653 6.74873 0.669922 6.78674 0.669922C6.82474 0.669922 6.86234 0.677653 6.89726 0.692645C6.93219 0.707637 6.96369 0.729575 6.98987 0.757127L6.99352 0.760782C7.04751 0.817419 7.07763 0.892665 7.07763 0.970914C7.07763 1.04916 7.04751 1.12441 6.99352 1.18105L3.7593 4.57545C3.73086 4.60531 3.69665 4.62907 3.65875 4.64531C3.62085 4.66155 3.58005 4.66992 3.53882 4.66992C3.49758 4.66992 3.45678 4.66155 3.41888 4.64531C3.38098 4.62907 3.34677 4.60531 3.31833 4.57545Z"
            fill="white"
          />
        </svg>
      </div>
      <div
        className={
          isMobile
            ? styles["language-list-wrapper--mobile"]
            : styles["language-list-wrapper"]
        }
      >
        <ul
          className={
            isMobile
              ? selected
                ? styles["language__list--selected"]
                : styles["language__list--unselected"]
              : styles["language__list--selected"]
          }
        >
          {languages.languages.map((l: LocaleKeys, key) => {
            if (l.code !== locale) {
              return (
                <li
                  key={l.code}
                  onClick={() => {
                    router.replace(
                      redirectPage(
                        locale as Locales,
                        l.code as Locales,
                        pathname
                      ),
                      {
                        locale: l.code,
                      }
                    );
                  }}
                  className={styles.list__li}
                >
                  <ImageContainer
                    image={`/flags${l.image}`}
                    width={l.width}
                    height={l.height}
                    alt={l.alt}
                    title={l.title}
                    containerStyle={styles["container-flag"]}
                  />
                  <MenuItem
                    title={t(`${key}.name`)}
                    isActive={false}
                    href={pathname}
                    setExpandMenu={() => false}
                    style={isMobile ? styles["language-selector__item"] : ""}
                  />
                </li>
              );
            }
            return null;
          })}
        </ul>
      </div>
    </div>
  );
}
